/**
 * Vue Router
 *
 * @library
 *
 * https://router.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Router from 'vue-router'
import Meta from 'vue-meta'

// Routes
import paths from './paths'
// import Dashboard from "../views/Dashboard";
// import Icons from "../views/Icons";
// import UserProfile from "../views/UserProfile";
// import TableList from "../views/TableList";

import {Auth, } from 'aws-amplify';
import tool_app from '../utils/tool_app'

// function lg () {
//   tool_app.lg()
// }

// function route (p, path, view, name) {
//   return {
//     name: name || view,
//     path,
//     component: (resovle) => import(
//       `@/views/${view}.vue`
//     ).then(resovle),
//     beforeEnter: async (from, to, next) => {
//
//         if(p.authRequired !== undefined && p.authRequired === true) {
//           await Auth.currentAuthenticatedUser()
//             .then(() => next())
//             .catch(() => next('/notifications'));
//           // return next('/notifications');
//         }
//       next()
//     }
//     // beforeEnter: () => (from, to, next) => {
//     //   // if(p.authRequired !== undefined && p.authRequired === true) {
//     //   //   return next('/Notifications');
//     //   // }
//     //   next(to)
//     //   // if (store.getters.getIsAuth) return next() // isAuth === true면 페이지 이동
//     //   // next('/') // isAuth === false면 다시 로그인 화면으로 이동
//     // }
//   }
// }

Vue.use(Router)

let obj = {
  lg: function (...args) {
    // let args = Array.prototype.slice.call(arguments);
    // console.log.apply(console, args);
    tool_app.lg('router] ', ...args);
  },
  route: function (p, path, view, name) {
    return {
      name: name || view,
      path,
      component: (resovle) => import(
        `@/views/${view}.vue`
        ).then(resovle),
      beforeEnter: async (from, to, next) => {
        obj.lg('p: ', p, ' from: ', from, ' to:', to);
        if(p.path === '/sign') {
          Auth.currentAuthenticatedUser()
            .then((user) => {
              obj.lg('user 1: no', user)
              next('/')
            })
            .catch((e) => {
              obj.lg('user 2: no ', e)
              next()
            });
          // next()
        }
        else {
            Auth.currentAuthenticatedUser()
              .then((user) => {
                obj.lg('user 1: no user:', user, ' from:', from, ' to:', to)
                next()
              })
              .catch((e) => {
                obj.lg('user 2: no ', e)
                next('/sign')
              });
        }
          // next()

        // if(p.authRequired !== undefined && p.authRequired === true) {
        //   Auth.currentAuthenticatedUser()
        //     .then((user) => {
        //       obj.lg('user 1: no', user)
        //       next()
        //     })
        //     .catch((e) => {
        //       obj.lg('user 2: no ', e)
        //       next('/notifications')
        //     });
        //   // return next('/notifications');
        // }
        // else {
        //   next()
        // }
      },
      props: true,
      // beforeEnter: () => (from, to, next) => {
      //   // if(p.authRequired !== undefined && p.authRequired === true) {
      //   //   return next('/Notifications');
      //   // }
      //   next(to)
      //   // if (store.getters.getIsAuth) return next() // isAuth === true면 페이지 이동
      //   // next('/') // isAuth === false면 다시 로그인 화면으로 이동
      // }
    }
  },
};

// // Create a new router
const router = new Router({
  // mode: 'history',
  routes: paths.map(path => obj.route(path, path.path, path.view, path.name)).concat([
    // { path: '*', redirect: '/dashboard' }
    { path: '*', redirect: tool_app.path_default }
  ]),
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  }
})
// console.log('asd ', router);
// for (let i = 0; i < router.options.routes.length; i++) {
//   console.log('asd ', i, ' ', router.options.routes[i]);
// }

// router.beforeEach((to, from, next) => {
//   console.log('router.beforeEach \nto:', to, ' \nfrom:', from);
//   if(to.authRequired !== undefined && to.authRequired === true) {
//     return next('/Notifications');
//   }
//   return next();
//
//   // // redirect to login page if not logged in and trying to access a restricted page
//   // const publicPages = ['/login', '/register'];
//   // const authRequired = !publicPages.includes(to.path);
//   // const loggedIn = localStorage.getItem('user');
//   //
//   // if (authRequired && !loggedIn) {
//   //   return next('/login');
//   // }
//   //
//   // next();
// })

Vue.use(Meta)

// Bootstrap Analytics
// Set in .env
// https://github.com/MatteoGabriele/vue-analytics
if (process.env.GOOGLE_ANALYTICS) {
  Vue.use(VueAnalytics, {
    id: process.env.GOOGLE_ANALYTICS,
    router,
    autoTracking: {
      page: process.env.NODE_ENV !== 'development'
    }
  })
}

export default router
